import { RrsCategory } from "server/models"
import { inferLiteral } from "client/utils"
import { TableGroupedIds } from "client/components"
import * as types from "./types"


export const setRrsCategoryBaseRoute = (baseRoute: string) => ({
    type: inferLiteral(types.RRS_CATEGORY_BASE_ROUTE),
    baseRoute,
})


export const setRrsCategoryList = (categoryList: types.RrsCategoryList) => ({
    type: inferLiteral(types.RRS_CATEGORY_LIST),
    categoryList,
})
export const setRrsCategoryIds = (categoryIds: TableGroupedIds[]) => ({
    type: inferLiteral(types.RRS_CATEGORY_IDS),
    categoryIds,
})
export const setRrsCategoryChildParent = (childParent: types.RrsCategoryChildParent) => ({
    type: inferLiteral(types.RRS_CATEGORY_CHILD_PARENT),
    childParent,
})
export const setRrsCategoryEdit = (category: RrsCategory) => ({
    type: inferLiteral(types.RRS_CATEGORY_EDIT),
    category,
})


export const setRrsCategoryFilters = (filters: types.RrsCategoryFilters) => ({
    type: inferLiteral(types.RRS_CATEGORY_FILTERS),
    filters,
})


// status change
export const setRrsCategoryStatusActive = (statusActive: number) => ({
    type: inferLiteral(types.RRS_CATEGORY_STATUS_ACTIVE),
    statusActive,
})


// confirm delete
export const setRrsCategoryActive = (active: RrsCategory) => ({
    type: inferLiteral(types.RRS_CATEGORY_ACTIVE),
    active,
})
export const setRrsCategoryShowConfirmDelete = (show: boolean) => ({
    type: inferLiteral(types.RRS_CATEGORY_SHOW_CONFIRM_DELETE),
    show,
})


export const setRrsCategoryReloadList = (value: boolean) => ({
    type: inferLiteral(types.RRS_CATEGORY_RELOAD_LIST),
    value,
})
export const setRrsCategoryReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.RRS_CATEGORY_RELOAD_EDIT),
    value,
})
